import Navbar from './components/layouts/Navbar'
import Home from './components/pages/Home'
import ContactUs from './components/pages/ContactUs';
import Services from './components/pages/services/Services';
import TechnologyConsultingServices from './components/pages/services/TechNologyConsultingService';
import Footer from './components/layouts/Footer';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import ProductManagement from './components/pages/services/ProductManagement';
import WorkforceStrategeAndPlans from './components/pages/services/WorkforceStrategeAndPlans';
import ApplicationAndProductMaintanence from './components/pages/services/ApplicationAndProductMaintanence';
import CloudOps from './components/pages/services/CloudOps';
import About from './components/pages/About';

function App() {
  return (
    <div className="App">
      <Navbar/>
        <Routes>
          <Route path="/" element={<Home />} />  
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/Technology-Consulting-Services" element={<TechnologyConsultingServices />} />
          <Route path="/product-management" element={<ProductManagement/>} />
          <Route path="/workforce-strategy-and-plans" element={<WorkforceStrategeAndPlans/>} />
          <Route path="/Application-and-product-maintanence" element={<ApplicationAndProductMaintanence/>} />
          <Route path="/CloudOps" element={<CloudOps/>} />
          <Route path="/About" element={<About/>} />
        </Routes>
        <Footer/>
    </div>
  );
}

export default App;
